import { useState } from "react";
import { useTranslation } from "react-i18next";
import { ChevronDownIcon } from "@heroicons/react/24/outline";
import USIcon from "@/assets/Img/Flags/USIcon.png";
import MXIcon from "@/assets/Img/Flags/MXIcon.png";
import classNames from "classnames";

interface LanguageSelectorProps {
  className?: string;
  blackText?: boolean;
  onClick?: () => void;
}

export const LanguageSelector = ({
  className,
  blackText = false,
  onClick,
}: LanguageSelectorProps) => {
  const { i18n } = useTranslation("global");
  const currentLanguage = i18n.language;

  const [languageTouched, setLanguageTouched] = useState<boolean>(false);

  return (
    <div className={className}>
      <div
        className={classNames(
          "h-10 flex gap-2 items-center lg:hover:opacity-90 rounded px-2 -ml-2 cursor-pointer",
          {
            "bg-gray-800/20": languageTouched,
            "text-white": !blackText,
            "text-black": blackText,
          }
        )}
        onTouchStart={() => setLanguageTouched(true)}
        onTouchEnd={() => setLanguageTouched(false)}
        onClick={onClick && onClick}
      >
        <img
          className="h-6 lg:h-8 w-6 lg:w-8 rounded-full object-cover"
          src={currentLanguage === "en" ? USIcon : MXIcon}
          alt="Language flag"
        />
        <p className="hidden">{currentLanguage?.toUpperCase()}</p>
        <ChevronDownIcon className="w-4 h-4 hidden" />
      </div>
    </div>
  );
};
